import React, { Component } from 'react'
import { Col, Input, InputNumber, Modal, Row } from 'antd'
import * as _ from 'lodash'

class HandleProposalShipmentModal extends Component {
  class = 'HandleProposalShipmentModal';

  state = {
    inputs: {
      ddt: undefined,
      bds: undefined,
      packages: undefined,
      pallet: undefined
    }
  }


  constructor(props, context) {
    super(props, context);

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    let ddt = _.get(this.props, 'obj.ddt', undefined);
    let bds = _.get(this.props, 'obj.bds', undefined);
    let packages = _.get(this.props, 'obj.packages', undefined);
    let pallet = _.get(this.props, 'obj.pallet', undefined);

    if (_.isNull(ddt)) {
      ddt = undefined;
    }

    if (_.isNull(bds)) {
      bds = undefined;
    }

    if (_.isNull(packages)) {
      packages = undefined;
    }

    if (_.isNull(pallet)) {
      pallet = undefined;
    }

    this.setState({
      inputs: {
        ddt,
        bds,
        packages,
        pallet
      }
    });
  }

  onChange(value, state) {
    this.setState({inputs: {...this.state.inputs, [state]: value}});
  }

  handleOk() {
    const { inputs } = this.state;

    this.props.onOkCallback({
      ddt: inputs.ddt,
      bds: inputs.bds,
      packages: inputs.packages,
      pallet: inputs.pallet
    });
  }

  render() {
    const { inputs } = this.state;
    return (
      <Modal
        title={`Conferma invio merce ${this.props.obj.storeName}`}
        width={800}
        visible={this.props.visible}
        okText="Salva"
        cancelText="Annulla"
        onOk={() => this.handleOk()}
        onCancel={this.props.onCancelCallback}>
        <div>
          <Row gutter={16}>
            <Col span={12}>
              <Input
                placeholder="Numero DDT"
                size="large"
                id={`${this.class}-input-ddt`}
                value={inputs.ddt}
                onChange={(e) => this.onChange(e.target.value, 'ddt')}
                allowClear
              />
            </Col>
            <Col span={12}>
              <Input
                placeholder="Numero BDS"
                size="large"
                value={inputs.bds}
                id={`${this.class}-input-bds`}
                onChange={(e) => this.onChange(e.target.value, 'bds')}
                allowClear
              />
            </Col>
          </Row>
          <Row gutter={16} style={{marginTop: 16}}>
            <Col span={12}>
              <InputNumber
                style={{width: '100%'}}
                placeholder="Numero colli"
                size="large"
                value={inputs.packages}
                id={`${this.class}-input-packages`}
                onChange={(value) => this.onChange(value, 'packages')}
                allowClear
              />
            </Col>
            <Col span={12}>
              <InputNumber
                style={{width: '100%'}}
                placeholder="Numero pallet"
                size="large"
                value={inputs.pallet}
                id={`${this.class}-input-pallet`}
                onChange={(value) => this.onChange(value, 'pallet')}
                allowClear
              />
            </Col>
          </Row>
        </div>
      </Modal>
    )
  }
}
export default HandleProposalShipmentModal



// WEBPACK FOOTER //
// ./src/components/HandleProposalShipment/index.js